<template>
  <!-- Payment information -->
  <div class="paymentInformation">
    <!-- 单价、定时刷新数据时间 -->
    <div class="feeTitle" :class="{ titleMargin: !isHome }">
      <!--      <div class="feeTitle-name" v-if="isHome">1 {{ pageData.cryptoInfo.crypto }} ≈ {{ pageData.feeInfo.cryptoPrice }} {{ pageData.fiatCurrencyInfo.fiat }}</div>-->
      <div class="feeTitle-value">
        <div class="loading-svg">
          <img src="@/assets/images/includedDetails/SellTime.png" alt="" />
        </div>
        <div class="feeTitle-value-text">
          <span>{{ timeDownNumber }}</span
          >{{ $t("buyFee_components.codeSecond") }}
        </div>
      </div>
    </div>
    <div
      class="fee-content"
      :class="{ contentMargin: isHome, 'fee-content-height': detailsState }"
    >
      <div
        class="fee-content-title"
        :class="{ clearTitleBorder: detailsState }"
        @click="expandCollapse"
      >
        <div class="left">
          {{ $t("buyFee_components.title") }}
          <span
            >{{ pageData.feeInfo.fiatSumAmount }}
            {{ pageData.fiatCurrencyInfo.code }}</span
          >
        </div>
        <div class="right">
          <img :src="detailsState ? image_Top : imageBottom" />
        </div>
      </div>
      <!-- 详细费用信息 -->
      <div
        class="fee-content-details"
        v-if="detailsState"
        :class="{ openAnimation: detailsState }"
      >
        <!--  v-if="detailsState" :class="{'openAnimation': detailsState}" -->
        <!-- ramp fee -->
        <div class="fee-content-details-line">
          <div class="title">
            {{ $t("buyFee_components.rampFee") }}
            <el-popover
              placement="top"
              trigger="click"
              :offset="-18"
              v-model="popover_state"
            >
              <p>{{ $t("buyFee_components.tips") }}</p>
              <div slot="reference">
                <img
                  class="tipsIcon"
                  src="@/assets/images/includedDetails/exclamatoryMarkIcon.png"
                />
              </div>
            </el-popover>
          </div>
          <!-- 确认支付页隐藏rampFee的as low as提示文案(isHome===false有值为确认订单页) -->
          <!-- 无折扣rampFee -->
          <div class="value">
            <span class="minText" v-if="isHome">{{
              $t("buyFee_components.rampFeeTips")
            }}</span>
            {{ pageData.fiatCurrencyInfo.symbol }}
            {{ pageData.feeInfo.rampFee }}
          </div>
        </div>
        <!-- network fee -->
        <div class="fee-content-details-line">
          <div class="title">{{ $t("buyFee_components.networkFee") }}</div>
          <div class="value">
            {{ pageData.fiatCurrencyInfo.symbol }}
            {{ pageData.feeInfo.networkFee }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 买币费用展示组件
 * type 1 - 首页轮询价格、2 - 只触发一次
 * isHome - 是否首页调用
 * payWayCode - 选择支付方式后带入支付方式code
 */
import common from "../../utils/common";
import { noData } from "@/utils";
import { mapState } from "vuex";
import { hashQuery } from "@/utils/publicRequest";

export default {
  name: "includedDetails",
  props: {
    // type: {
    //   type: Number,
    //   default: null
    // },
    //是否在首页
    isHome: {
      type: Boolean,
      default: null,
    },
    //确认订单页支付方式code
    payWayCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      triggerType: "hover",
      popover_state: false,

      timeDown: 60,
      timeOut: null,
      detailsState: false,

      timeDownNumber: 15,

      imageBottom: require("@/assets/images/includedDetails/blackDownIcon1.png"),
      image_Top: require("@/assets/images/includedDetails/imageTop.png"),
    };
  },
  mounted() {
    if (!this.isHome) {
      this.scenarioVerification();
    }
  },
  activated() {
    if (!this.isHome) {
      this.scenarioVerification();
    }
  },
  destroyed() {
    this.timeDownNumber = 15;
    window.clearInterval(this.timeOut);
    this.timeOut = null;
  },
  deactivated() {
    this.timeDownNumber = 15;
    window.clearInterval(this.timeOut);
    this.timeOut = null;
  },
  computed: {
    ...mapState("buyNftHome", {
      fiatCurrencyInfo: (state) => state.fiatCurrency,
      fiatCurrencyAmount: (state) => state.commodityPrice,
      feeInfo: (state) => state.feeInfo,
      payWay_rampFee: (state) => state.payWay_rampFee,
      nftInfo: (state) => state.nftInfo,
      usdToEXR: (state) => state.usdToEXR,
    }),
    ...mapState("merchantInfo", {
      merchantBuyType: (state) => state.merchantBuyType,
    }),

    /**
     * 页面所展示费用信息,区分ramp二次支付展示信息和ramp流程展示信息
     * 二次支付条件 - 存在$route.query.pathHistry
     * @returns {{fiatCurrencyInfo, feeInfo, fiatCurrencyAmount}}
     */
    pageData() {
      let params = {};
      //首页场景数据、商户确认订单数据
      params = {
        fiatCurrencyInfo: this.fiatCurrencyInfo,
        fiatCurrencyAmount: this.fiatCurrencyAmount,
        feeInfo: this.feeInfo,
      };
      return params;
    },
  },
  methods: {
    //分场景调用不同费用方法
    scenarioVerification() {
      //首页默认展开费用信息
      this.isHome ? (this.detailsState = true) : (this.detailsState = false);
      //判断是pc还是移动端，用于展示的提示信息是click还是hover触发
      this.triggerType = common.equipmentEnd === "pc" ? "hover" : "click";
      this.queryFee();
      this.timingSetting();
    },

    /**
     * 15秒定时刷新费用数据
     */
    timingSetting() {
      this.timeDownNumber = 15;
      window.clearInterval(this.timeOut);
      this.timeOut = null;
      this.timeOut = setInterval(() => {
        if (this.timeDownNumber === 1) {
          this.timeDownNumber = 15;
          this.queryFee();
        } else {
          this.timeDownNumber -= 1;
        }
      }, 1000);
    },

    /**
     * 获取费用数据
     * 场景: ramp流程、二次支付
     * 商户信息有效携带商户信息
     */
    queryFee() {
      let _this = this;
      this.$nextTick(() => {
        let params = {
          fiat: this.fiatCurrencyInfo.code,
          crypto: this.nftInfo.crypto || "",
          cryptoAmount: this.nftInfo.cryptoAmount || "",
          name: this.nftInfo.name,
          payWayCode: this.payWayCode,
        };
        //带入商户信息
        let merchantInfo = "";
        if (JSON.stringify(hashQuery().query) !== "{}") {
          merchantInfo = "?" + JSON.parse(JSON.stringify(hashQuery())).fullPath;
        } else {
          merchantInfo = JSON.parse(sessionStorage.getItem("merchantInfo"))
            ? "?" +
              JSON.parse(sessionStorage.getItem("merchantInfo")).merchantParam
            : "";
        }
        this.$axios
          .post(this.$api.post_feeInfo + merchantInfo, params, "")
          .then((res) => {
            if (res && res.data) {
              _this.storeData(res);
            }
          });
      });
    },

    /**
     * 分场景存储费用信息
     * @param res 需要存储费用信息
     */
    storeData(res) {
      if (this.isHome) {
        //存储费用信息
        let feeInfo = {
          rampFee: noData(res.data.rampFee), //通道费
          networkFee: res.data.netWorkFee, //网络费
          cryptoPrice: noData(res.data.cryptoPrice), //加密货币价格
          fiatSumAmount: res.data.fiatSumAmount,
        };
        this.$store.commit("buyNftHome/set_feeInfo", feeInfo);

        this.$store.commit(
          "buyNftHome/set_commodityPrice",
          res.data.fiatSumAmount,
        );
        this.$store.commit("buyNftHome/set_payAmount", res.data.fiatSumAmount);

        this.$store.commit("buyNftHome/set_amount", res.data.fiatSumAmount);
        this.$store.commit("buyNftHome/set_nftAmount", res.data.fiatSumAmount);
        return;
      }
      //存储费用信息
      let feeInfo = {
        rampFee: noData(res.data.rampFee), //通道费
        networkFee: res.data.netWorkFee, //网络费
        cryptoPrice: noData(res.data.cryptoPrice), //加密货币价格
        fiatSumAmount: res.data.fiatSumAmount,
      };
      this.$store.commit("buyNftHome/set_feeInfo", feeInfo);

      //币本位商户更新展示金额
      if (this.merchantBuyType === "CRYPTO") {
        this.$store.commit("buyNftHome/set_payAmount", res.data.fiatSumAmount);
      }

      // this.$store.commit("buyNftHome/set_commodityPrice",res.data.fiatSumAmount);
      // this.$store.commit("buyNftHome/set_payAmount",res.data.fiatSumAmount);

      // this.$store.commit("buyNftHome/set_amount",res.data.fiatSumAmount);
      // this.$store.commit("buyNftHome/set_nftAmount",res.data.fiatSumAmount);

      // let amount = this.nftInfo.nftAmount  && this.nftInfo.nftAmount > 0? Number(this.nftInfo.nftAmount) + this.payWay_rampFee : this.nftInfo.amount / this.usdToEXR;

      // let amount = Number(res.data.fiatSumAmount) + this.payWay_rampFee;
      // console.log(res.data.fiatSumAmount,'----fiatSumAmount',this.payWay_rampFee)
      // //小数点保留 规则为如果小数点保留为0并且有小数位  则向上+1 否则保留小数位并且小数位向上进1
      // let payAmountPre
      // if(this.fiatCurrencyInfo.decimalDigits === 0){
      //   payAmountPre = Math.ceil(amount)
      // }else {
      //   //乘小数位
      //   let numLength = '1'
      //   //具体保留几位小数
      //   let sumLength = this.fiatCurrencyInfo.decimalDigits
      //   for (let i = 0; i < sumLength; i++) {
      //     numLength += '0'
      //   }
      //   //保留完小数再除进1
      //   payAmountPre = Math.ceil((amount) * numLength) / numLength
      // }
      // this.$store.commit("buyNftHome/set_nftAmount",payAmountPre);
      // this.$store.commit("buyNftHome/set_amount",payAmountPre);
      // this.$store.commit("buyNftHome/set_commodityPrice",payAmountPre);
      // this.$store.commit("buyNftHome/set_payAmount",payAmountPre);
      // //存储费用信息
      // let feeInfo = {
      //   rampFee: noData(res.data.rampFee),  //通道费
      //   networkFee: res.data.netWorkFee, //网络费
      //   cryptoPrice: noData(res.data.cryptoPrice), //加密货币价格
      //   fiatSumAmount: payAmountPre,
      // }
      // this.$store.commit("buyNftHome/set_feeInfo",feeInfo);
    },

    //展开或收起费用
    expandCollapse() {
      this.detailsState === true
        ? (this.detailsState = false)
        : (this.detailsState = true);
      if (this.detailsState === true) {
        setTimeout(() => {
          this.$parent.$refs.IncludedDetails_ref.$el.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "end",
          });
        });
      }
    },
  },
};
</script>
<style lang="scss">
.el-popover .popper__arrow::after {
  margin-left: -1px !important;
  border-top-color: #333333 !important;
}
</style>
<style lang="scss" scoped>
.paymentInformation {
  .titleMargin {
    margin-top: 0.18rem !important;
  }

  .feeTitle {
    font-size: 13px;
    font-weight: normal;
    color: #6e7687;
    line-height: 15px;
    display: flex;
    align-items: center;
    padding: 0 0.2rem 0;
    .feeTitle-name {
      font-family: Regular;
      font-weight: 400;
      color: #031633;
    }
    .feeTitle-value {
      font-family: Regular;
      font-weight: 400;
      display: flex;
      align-items: center;
      margin-left: auto;
      .loading-svg {
        margin-right: 0.04rem;

        margin-top: 0.02rem;
        img {
          height: 0.14rem;
        }
      }
      .feeTitle-value-text {
        color: #6e7687;
        span {
          display: inline-block;
          width: 0.15rem;
          text-align: center;
        }
      }
    }
  }

  .contentMargin {
    margin-top: 0.4rem !important;
  }

  .fee-content {
    position: relative;
    background: linear-gradient(0deg, #ffffff, #ffffff), #f4f5f7;
    border: 1px solid #d9d9d9;
    border-radius: 0.16rem;
    margin-top: 0.08rem;
    padding: 0 0.2rem 0 0.2rem;
    .fee-content-title {
      min-height: 0.6rem;
      border-bottom: 1px dashed #ffffff;
      display: flex;
      align-items: center;
      font-size: 0.16rem;
      font-family: Regular;
      font-weight: 400;
      color: #6e7687;
      cursor: pointer;
      span {
        font-weight: bold;
      }
      .left {
        word-break: break-all;
        font-size: 0.13rem;
        font-family: Regular;
        font-weight: 400;
        color: #6e7687;
        span {
          color: rgba(3, 22, 51, 1);
          font-family: Regular;
          font-weight: 400;
          font-weight: bold;
        }
        span:nth-of-type(1) {
          font-weight: 400;
          color: #031633;
          font-weight: bold;
        }
      }
      .right {
        margin-left: auto;
        img {
          width: 0.24rem;
        }
      }
    }

    .clearTitleBorder {
      border-bottom: 1px dashed #d9d9d9;
    }

    .fee-content-details {
      padding: 0 0 0.2rem 0;
      overflow: hidden;
      .fee-content-details-line {
        display: flex;
        align-items: center;
        margin-top: 0.16rem;
        .title {
          display: flex;
          align-items: center;
          font-size: 0.13rem;
          font-family: Regular;
          font-weight: 400;
          color: #6e7687;
          .tipsIcon {
            width: 0.12rem;
            height: 0.12rem;
            margin-left: 0.08rem;
            display: flex;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .value {
          margin-left: auto;
          display: flex;
          align-items: center;
          font-size: 0.13rem;
          font-family: Regular;
          font-weight: 400;
          color: #6e7687;
          .minText {
            font-family: Regular;
            font-weight: 400;
            color: #c2c2c2;
            margin-right: 0.04rem;
            margin-top: -0.02rem;
          }
        }
      }
    }
  }

  //展开过渡动画
  .openAnimation {
    animation: openHandler 0.2s;
  }
  .fee-content-height {
    min-height: 1.5rem;
  }
}

//展开过渡动画
@keyframes openHandler {
  0% {
    height: 0.1rem;
    //transform: scale(1,0);
  }
  10% {
    height: 0.2rem;
  }
  20% {
    height: 0.3rem;
    //transform: scale(1,1.2);
  }
  30% {
    height: 0.4rem;
  }
  50% {
    height: 0.5rem;
    //transform: scale(1,0.85);
  }
  60% {
    height: 0.6rem;
    //transform: scale(1,1.05);
  }
  70% {
    height: 0.7rem;
    //transform: scale(1,1);
  }
}

.wordValue {
  display: flex;
  .minText {
    display: block;
    margin-top: 0.03rem !important;
  }
  p:nth-of-type(1) {
    color: #0ab24d;
    font-weight: 700;
    font-size: 0.16rem;
    margin: 0 0.04rem 0;
  }
  p:nth-of-type(2) {
    text-decoration: line-through;
    text-decoration-color: #0ab24d;
    color: #bfbfbf;
    font-size: 0.11rem;
    margin-top: 0.03rem;
  }
}
</style>
